'use strict';

const React = require('react');

const PropTypes = require('prop-types');

/**
 * Render the Gallery Photo Pagination
 *
 * @param {object} styles
 * @param {number} photoIndex
 * @param {number} totalPhotos
 */
const GalleryPhotoPagination = function({ styles, photoIndex, totalPhotos }) {
    return (
        <div className={styles.wrapper}>
            <span className={styles.pagination}>
                {photoIndex + 1} of {totalPhotos}
            </span>
        </div>
    );
};

GalleryPhotoPagination.propTypes = {
    photoIndex: PropTypes.number.isRequired,
    totalPhotos: PropTypes.number.isRequired,
    styles: PropTypes.shape({
        wrapper: PropTypes.string,
        pagination: PropTypes.string,
    }).isRequired,
};

GalleryPhotoPagination.defaultProps = {
    styles: require('./GalleryPhotoPagination-style.scss'),
};

module.exports = GalleryPhotoPagination;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/GalleryPhotoPagination.jsx